import React, { useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import {
  isBlockedModalRegionCached,
  isUserInBlockedModalRegion,
  syncGeoModalRegionFromCache,
} from "../../utils"
import AiEfficiencyModal from "./AiEfficiencyModal"

const AiEfficiencyModalGate = () => {
  const [allowed, setAllowed] = useState(false)
  const location = useLocation()
  const isArabic = /^\/ar(?:\/|$)/.test(location.pathname)

  useEffect(() => {
    syncGeoModalRegionFromCache()
    if (isBlockedModalRegionCached()) return

    let cancelled = false

    isUserInBlockedModalRegion()
      .then(blocked => {
        if (!cancelled && !blocked) setAllowed(true)
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [])

  if (!allowed) return null

  return <AiEfficiencyModal language={isArabic ? "ar" : "en"} />
}

export default AiEfficiencyModalGate
